import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledButton from '../Common/StyledButton';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/rootReducer';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';

interface IStartActivityCardProps {
  handleNext: () => void;
}

function StartActivityCard({ handleNext }: IStartActivityCardProps) {
  const { t } = useTranslation();
  const isActiveClient = useAppSelector(
    (state: RootState) => state.client.selectedClient?.isActive
  );
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        p="32px"
        width="374px"
        bgcolor="#fff"
        borderRadius="5px"
      >
        <Box display="flex" flexDirection="column" gap="36px">
          <Box display="flex" alignItems="center" flexDirection="column">
            <Typography variant="h5" color="primary">
              {t('activity.createActivity.activityCard.youDontHaveAny')}
            </Typography>
            <Typography variant="h5" color="primary">
              {t('activity.createActivity.activityCard.activitiesCreated')}
            </Typography>
          </Box>
          <Box textAlign="justify" display="flex">
            <Typography
              variant="bodyRegular"
              textAlign="center"
              width="100%"
              sx={{ flexGrow: '1' }}
              color="primary"
            >
              {t('activity.createActivity.activityCard.activityDescription')}
            </Typography>
          </Box>
          <Box>
            {checkPermissions(UserPermissionType.ACTIVITY_MODULE_ASSIGN_NEW_ACTIVITY) && (
              <StyledButton fullWidth onClick={handleNext} endIcon disabled={!isActiveClient}>
                {t('activity.createActivity.activityCard.startBuilding')}
              </StyledButton>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default StartActivityCard;
